// Power Control Units Action Types

// Data operations
export const SAVE_POWER_CONTROL_UNITS = 'SAVE_POWER_CONTROL_UNITS';
export const APPEND_POWER_CONTROL_UNITS = 'APPEND_POWER_CONTROL_UNITS';
export const UPDATE_POWER_CONTROL_UNIT = 'UPDATE_POWER_CONTROL_UNIT';
export const SELECT_POWER_CONTROL_UNIT = 'SELECT_POWER_CONTROL_UNIT';
export const SET_POWER_CONTROL_UNIT_OPERATIONAL_MODE = 'SET_POWER_CONTROL_UNIT_OPERATIONAL_MODE';

// Pagination & filters
export const SET_POWER_CONTROL_UNITS_PAGINATION_DATA = 'SET_POWER_CONTROL_UNITS_PAGINATION_DATA';
export const RESET_POWER_CONTROL_UNITS_PAGINATION_DATA = 'RESET_POWER_CONTROL_UNITS_PAGINATION_DATA';
export const SET_POWER_CONTROL_UNITS_FILTER = 'SET_POWER_CONTROL_UNITS_FILTER';
export const RESET_POWER_CONTROL_UNITS_FILTERS = 'RESET_POWER_CONTROL_UNITS_FILTERS';
export const SET_POWER_CONTROL_UNITS_ORDER = 'SET_POWER_CONTROL_UNITS_ORDER';

// Events & logs
export const SAVE_POWER_CONTROL_UNIT_EVENTS = 'SAVE_POWER_CONTROL_UNIT_EVENTS';
export const APPEND_POWER_CONTROL_UNIT_EVENTS = 'APPEND_POWER_CONTROL_UNIT_EVENTS';
export const SET_POWER_CONTROL_UNIT_EVENTS_PAGINATION_DATA = 'SET_POWER_CONTROL_UNIT_EVENTS_PAGINATION_DATA';
export const RESET_POWER_CONTROL_UNIT_EVENTS_PAGINATION_DATA = 'RESET_POWER_CONTROL_UNIT_EVENTS_PAGINATION_DATA';
export const SET_POWER_CONTROL_UNIT_EVENTS_FILTER = 'SET_POWER_CONTROL_UNIT_EVENTS_FILTER';

// Statistics
export const SAVE_POWER_CONTROL_UNITS_OVERVIEW = 'SAVE_POWER_CONTROL_UNITS_OVERVIEW';
export const SAVE_POWER_CONTROL_UNITS_POWER_ON_HOURS = 'SAVE_POWER_CONTROL_UNITS_POWER_ON_HOURS';
export const SAVE_POWER_CONTROL_UNITS_ENERGY_SUMMARY = 'SAVE_POWER_CONTROL_UNITS_ENERGY_SUMMARY';
export const SAVE_POWER_CONTROL_UNITS_ALERTS = 'SAVE_POWER_CONTROL_UNITS_ALERTS';

// Device binding
export const SAVE_POWER_CONTROL_UNIT_DEVICES = 'SAVE_POWER_CONTROL_UNIT_DEVICES';
